import { createAction } from "redux-actions";

export const setProjectFilters = createAction("SET_PROJECT_FILTERS");
